import React from 'react';
import { Tooltip, Typography } from '@mui/material';

function CustomTruncate({ text, maxLength = 30 }) {
  const shouldTruncate = text.length > maxLength;
  const displayText = shouldTruncate ? text.slice(0, maxLength) + '…' : text;

  return (
    <Tooltip title={shouldTruncate ? text : ''} arrow>
      <span style={{ cursor: shouldTruncate ? 'pointer' : 'default' }}>
        {displayText}
      </span>
    </Tooltip>
  );
}

export default CustomTruncate;
